import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { CurrentMentorsActions } from "../actions/currentClientActions";

export default function activeMenteeReducer(state = initialState.activeMentee, action: CurrentMentorsActions): boolean {
    switch (action.type) {
        case types.SESSION_HAS_ACTIVE_MENTEE: {
            return action.activeMentee;
        }
        default:
            return state;
    }
}
